import React from 'react'
import { Grid } from '@material-ui/core'
import { SelectDashboard } from 'Components/Form'
import BounceLoader from 'Components/BounceLoader'

const Filters = ({
  classes,
  chart,
  setChart,
  currentMonth,
  monthOptions = [],
  yearOptions = [],
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={3}>
        <SelectDashboard
          className={classes.spacing}
          options={yearOptions}
          input={{
            onChange: years =>
              setChart(chart => {
                let newYears = years.filter(year => year !== 'all')
                if (
                  (years.includes('all') && !chart.years.includes('all')) ||
                  years.length === 0
                ) {
                  newYears = ['all']
                }
                return {
                  ...chart,
                  years: newYears,
                }
              }),
            multiple: true,
          }}
          value={chart.years}
        />
      </Grid>
      {chart.type === 'month' ? (
        <Grid item xs={3}>
          <SelectDashboard
            className={classes.spacing}
            options={monthOptions}
            input={{
              onChange: months => {
                setChart(chart => ({
                  ...chart,
                  months: months.length === 0 ? [currentMonth] : months,
                }))
              },
              multiple: true,
            }}
            value={chart.months}
          />
        </Grid>
      ) : null}
      <Grid item xs={3}>
        {chart.isLoading ? <BounceLoader /> : null}
      </Grid>
    </Grid>
  )
}

export default Filters
